import styled from "styled-components";

export const Container = styled.section`
  margin-top: 10rem;
  padding: 4rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  h2 {
    text-align: center;
    font-size: 4rem;
    margin-bottom: 4rem;
    color: #ffffff;
    position: relative;
  }

  @media (max-width: 740px) {
    margin-top: 6rem;
    padding: 2rem 1rem;

    h2 {
      font-size: 2.5rem;
      margin-bottom: 3rem;
    }
  }
`;

export const BrandsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  width: 100%;
  max-width: 1200px;

  @media (max-width: 740px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1.5rem;
  }
`;

export const BrandCard = styled.div`
  background: rgba(30, 35, 45, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 2.5rem 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 1.8rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  transition: all 0.3s ease;
  min-height: 120px;

  &:hover {
    background: rgba(40, 45, 55, 0.9);
    border-color: var(--green);
    color: #ffffff;
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0, 224, 255, 0.2);
  }

  @media (max-width: 740px) {
    padding: 2rem 1.5rem;
    font-size: 1.5rem;
    min-height: 100px;
  }
`;
